export default "__VITE_ASSET__efe956db__"